<div *ngIf="notification" class="container-notification" [ngClass]="notificationClass()">
  <div class="container-element">
    <div class="container-icon" [ngClass]="notificationClass()">
      <app-icon [iconName]="icon" />
    </div>
    <div class="container-detail">
      <span class="title">
        {{ notification.title }}
        <span class="container-close-icon" (click)="closeNotification()">
          <app-icon iconName="close" />
        </span>
      </span>
      <span>{{ notification.detail }}</span>
    </div>
  </div>
</div>